module.exports = __webpack_public_path__ + "static/media/homescreen-illustration.4a043504.png";